var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.5,
    height: 108.863,
    viewBox: "0 0 117.5 108.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(23545 -18451.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M-234.722,748.613l5.838,3.343a.6.6,0,0,0,.824-.218.6.6,0,0,0-.218-.823l-6.2-3.585a.659.659,0,0,0-.727.073l-4.109,3.761,1.093.631Z",
    transform: "translate(-23239.102 17710.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M-88.623,899.312Z",
    transform: "translate(-23340.49 17608.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M-224.224,977.519l-.089.052h0l.407-.236-.163.094Z",
    transform: "translate(-23249.195 17555.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M-259.184,945.543h0Z",
    transform: "translate(-23225.732 17576.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M-222.628,977.03l-.011.006.04-.023-.013.008Z",
    transform: "translate(-23250.32 17555.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M-259.647,945.694l.031-.018.01-.006-.1.058h0l.034-.02Z",
    transform: "translate(-23225.381 17576.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M-223.07,977.235l.083-.048,0,0Z",
    transform: "translate(-23250.031 17555.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M-258.422,945.05l.014-.008-.042.025.011-.006Z",
    transform: "translate(-23226.227 17577.238)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M-259.759,945.862l-.014.008Z",
    transform: "translate(-23225.336 17576.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M-224.346,978.062l.011-.006h0Z",
    transform: "translate(-23249.172 17555.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M-259.151,945.487l-.032.018.018-.01Z",
    transform: "translate(-23225.732 17576.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M-222.408,976.949h0Z",
    transform: "translate(-23250.477 17555.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M-259.728,945.851l.007,0h0Z",
    transform: "translate(-23225.367 17576.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M-222.273,976.814l.048-.028Z",
    transform: "translate(-23250.566 17555.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M-259.791,945.892Z",
    transform: "translate(-23225.32 17576.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M-258.094,944.8l.025-.015.011-.006.024-.014-.093.054.013-.007Z",
    transform: "translate(-23226.443 17577.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M-258.727,945.117l-.134.078.127-.074Z",
    transform: "translate(-23225.949 17577.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M-258.971,945.4l.018-.01Z",
    transform: "translate(-23225.875 17577.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M-257.843,944.757l.007,0Z",
    transform: "translate(-23226.635 17577.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M-258.321,944.99l.043-.025Z",
    transform: "translate(-23226.313 17577.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M-258.189,944.941l.02-.012Z",
    transform: "translate(-23226.402 17577.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M-337.544,801.876l0,0,12.019-10.97a.569.569,0,0,0,.194-.509.669.669,0,0,0-.29-.46L-357.8,771.377a.6.6,0,0,0-.823.218.6.6,0,0,0,.218.824l31.444,18.144-11.58,10.562-11.079-6.39,0,1.4,9.944,5.738-9.981,5.8v.025l-1.211.7v-.024l-4.094,2.379v.019l-1.211.7v-.017l-13.614,7.914h0l-.313.182-13.834,8.042h-.024l-36.289-20.976v.018l-1.187-.7h0l-7.074-4.089,7.1-4.13,0-1.383-8.218,4.786L-441.2,790.563l11.434-6.638,8.417-4.887,0-1.394-21.164,12.289a.626.626,0,0,0-.315.46.571.571,0,0,0,.194.509l12.04,10.974-12.04,10.95a.6.6,0,0,0,.121.969l4.821,2.786a.6.6,0,0,0,.823-.218h0l-.527-.3-4.825-2.785,12.509-11.407h0l45.772,26.427h0l45.475-26.427v.01l.015-.009,12.509,11.407-12.592,7.315-.066,18.1-6.43,3.737-.518.3s0,.009.006.014a.6.6,0,0,0,.824.218l6.419-3.755a.565.565,0,0,0,.315-.509l.048-17.757,12.306-7.146a.6.6,0,0,0,.29-.46.569.569,0,0,0-.194-.509Z",
    transform: "translate(-23102.17 17694.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M-361.814,963.673l-45.772-26.426.066-18.238-1.632-.942-.512-.3,0,0a.6.6,0,0,0,.218.823l1.308.751-.049,17.9a.591.591,0,0,0,.291.509l45.785,26.429a.516.516,0,0,0,.606,0l29.142-16.933a.62.62,0,0,0,.218-.824h0l-.533.31Z",
    transform: "translate(-23124.426 17595.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M-217.758,940.065l.066-18.1-32.9,19.111L-263.1,929.664l-.134,36.827,29.133-16.93.533-.31a.626.626,0,0,0-.847-.218l-28.2,16.4v-.549c.007-1.849.032-9.137.119-33.851l11.483,10.489a.676.676,0,0,0,.727.073l31.977-18.58-.048,16.691-6.129,3.561a.625.625,0,0,0-.224.834l.518-.3Z",
    transform: "translate(-23223.008 17592.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M-217.348,864.734l-45.475,26.427,45.475-26.417Z",
    transform: "translate(-23223.285 17631.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M-112.464,876.035h0l.014.012h0l-.014-.012-11.57,6.72,0,.7,12.592-7.315-12.509-11.407-.015.009,0,.794Z",
    transform: "translate(-23316.664 17631.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M-88.665,899.274h0l.014.012Z",
    transform: "translate(-23340.463 17608.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M-259.73,945.86h0Z",
    transform: "translate(-23225.365 17576.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M-258.273,944.907l-.013.008-.02.012-.043.025-.014.008Z",
    transform: "translate(-23226.285 17577.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M-224.349,978.075Z",
    transform: "translate(-23249.17 17555.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M-258.4,945.066l-.017.01Z",
    transform: "translate(-23226.25 17577.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M-258.067,944.869l-.022.012Z",
    transform: "translate(-23226.469 17577.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M-259.779,945.887h0Z",
    transform: "translate(-23225.33 17576.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M-257.885,944.751l-.007,0-.024.014Z",
    transform: "translate(-23226.586 17577.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M-222.363,976.871l-.015.009-.029.017Z",
    transform: "translate(-23250.477 17555.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M-258.915,945.366l.018-.01Z",
    transform: "translate(-23225.914 17577.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M-258,944.825l-.025.015Z",
    transform: "translate(-23226.514 17577.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M-257.937,944.806l-.011.006Z",
    transform: "translate(-23226.564 17577.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M-259.185,945.545h0Z",
    transform: "translate(-23225.73 17576.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M-222.692,977.11l0,0Z",
    transform: "translate(-23250.285 17555.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M-222.68,977.079l.013-.008.011-.006Z",
    transform: "translate(-23250.293 17555.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M-224.041,977.713l.155-.09Z",
    transform: "translate(-23249.377 17555.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M-222.748,977.125l.018-.01Z",
    transform: "translate(-23250.248 17555.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M-222.829,977.162l0,0,.022-.013Z",
    transform: "translate(-23250.193 17555.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M-223.567,977.334l.163-.095.079-.046Z",
    transform: "translate(-23249.697 17555.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M-222.775,977.094l-.018.01-.022.013.058-.034-.013.008Z",
    transform: "translate(-23250.201 17555.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M-222.433,976.915h0l.029-.017-.041.024Z",
    transform: "translate(-23250.451 17555.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M-222.606,977.046l.016-.01Z",
    transform: "translate(-23250.344 17555.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M-258.454,945.1l-.011.007-.007,0Z",
    transform: "translate(-23226.211 17577.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M-222.557,976.992l.013-.008.024-.014Z",
    transform: "translate(-23250.377 17555.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M-222.517,976.97l.036-.021-.012.007Z",
    transform: "translate(-23250.402 17555.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M-217.416,883.476l0-.7-32.157,18.677.015-.009.048-.028h0l-.048.028-.044.025h0l-.036.021-.04.023-.058.034-.083.048-.407.236h0l-.011.006h0l.011-.006-11.58-10.538-.007,0h0l-.014.008,0,0h0l0,0,.014-.008h0l.007,0h0l.1-.058.071-.041h0l.032-.018.038-.022.018-.01.018-.01.134-.078.042-.025.043-.025.02-.011.093-.054.006,0,43.764-25.442.072.065,0-.794-45.475,26.417,12.509,11.407Z",
    transform: "translate(-23223.283 17631.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M-259.082,945.43l-.032.019-.014.008Z",
    transform: "translate(-23225.77 17576.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M-259.048,945.42l-.038.022.032-.019Z",
    transform: "translate(-23225.799 17576.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M-258.82,945.131l-.127.074-.018.01-.018.01-.006,0Z",
    transform: "translate(-23225.863 17577.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M-224.313,977.95h0l.089-.052Z",
    transform: "translate(-23249.195 17555.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M-259.166,945.511l-.018.01h0Z",
    transform: "translate(-23225.732 17576.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M-259.351,945.545l-.071.041-.01.006Z",
    transform: "translate(-23225.566 17576.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M-259.494,945.688l-.031.018Z",
    transform: "translate(-23225.502 17576.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M-259.576,945.742l-.025.014Z",
    transform: "translate(-23225.451 17576.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M-259.706,945.806h0l.034-.02Z",
    transform: "translate(-23225.381 17576.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M-259.33,945.545l-.071.041.071-.041Z",
    transform: "translate(-23225.586 17576.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M-402.725,864.735Z",
    transform: "translate(-23129.154 17631.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M-403.068,921.555l-.066,18.237,45.772,26.426.134-36.827h0L-369.737,940.8Zm33.729,19.7,11.507-10.489-.145,34.4-44.55-25.727.048-16.836,32.437,18.726A.631.631,0,0,0-369.339,941.252Z",
    transform: "translate(-23128.879 17593.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M-435.824,878.41l-4.118-2.374,11.49-10.481,0-.819-12.509,11.407,4.825,2.786.527.3A.6.6,0,0,0-435.824,878.41Z",
    transform: "translate(-23103.43 17631.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M-407.342,918.383l0-.71-1.326-.766a.628.628,0,0,0-.821.238l.512.3Z",
    transform: "translate(-23124.605 17596.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    height: 52.853,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -23531.879, 18496.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M-362.25,942.856Z",
    transform: "translate(-23153.561 17580.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M-402.462,866.929Z",
    transform: "translate(-23129.33 17629.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M-402.778,865.473h0c7.141,4.125,42.383,24.48,44.671,25.8h0c.158.092.152.088,0,0l-11.579,10.538-17.108-9.883c2.647,1.53,2.608,1.51-16.134-9.312l0,.71,33.331,19.244,12.508-11.407-45.772-26.427h0l0,.819Z",
    transform: "translate(-23129.014 17631.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M-265.926,945.847h0C-265.774,945.935-265.768,945.939-265.926,945.847Z",
    transform: "translate(-23221.195 17576.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M-376.757,749.033l-.594.345-.054,17.3.6-.349v1.381l-.6.352-.026,8.219,1.187.686.121-31.81c0-4.554,3.053-6.323,7.025-4.022h.024l34.5,19.938a16.811,16.811,0,0,1,7.631,13.178v.145L-327,790.423l.9-.521.313-.182.048-15.323v-.145a16.845,16.845,0,0,0-2.4-8.091,16.969,16.969,0,0,0-5.814-6.153l-34.521-19.913a.024.024,0,0,1-.024-.025A9.4,9.4,0,0,0-371.379,739l2.543-1.5c1.333-.751,3.125-.557,5.063.557l34.5,19.913c4.215,2.447,7.631,8.358,7.606,13.2l-.048,16.171,1.211-.7.048-15.469c.024-5.233-3.658-11.628-8.212-14.244L-361.3,738.083v-1.55c0-2.2.727-3.828,2.035-4.579,1.453-.848,3.537-.291,5.015.557h.024l34.5,19.937c4.239,2.447,7.631,8.5,7.606,13.178v.1l-.048,16.081,1.211-.7.048-15.377v-.145c0-5.063-3.585-11.507-8.212-14.2l-34.5-19.913c-.024,0-.024,0-.048-.024a9.05,9.05,0,0,0-2.883-1.066l2.568-1.5c1.308-.751,3.1-.557,5.039.557l34.52,19.937a16.722,16.722,0,0,1,7.607,13.179l-.048,16.171,1.211-.7.036-11.54-.594-.343v-1.4l.6.345.008-2.525c.024-5.233-3.682-11.6-8.212-14.244l-17.333-10-.473.429-1.09-.63.469-.43-16.095-9.284c-2.326-1.357-4.554-1.55-6.25-.557l-5.281,3.076h-.025c-1.672.993-2.592,2.98-2.616,5.62v.872l-.654-.388c-2.35-1.357-4.579-1.551-6.274-.557l-5.257,3.052a.024.024,0,0,1-.024.024c-1.7.993-2.616,2.98-2.616,5.62l-.009,2.827.614-.357Z",
    transform: "translate(-23146.17 17723.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M-239.66,760.262l.473-.429-1.093-.631-.47.43Z",
    transform: "translate(-23238.135 17702.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M-177.962,892.648l1.211-.7v-.019l-1.211.7Z",
    transform: "translate(-23280.381 17612.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M-161.746,883.23l1.211-.7V882.5l-1.211.7Z",
    transform: "translate(-23291.291 17619.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M-220.218,918.269h0l-.313.182Z",
    transform: "translate(-23251.738 17595.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M-159.747,843.271v.024l.593.342,0-1.4-.6-.345Z",
    transform: "translate(-23292.637 17646.641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M-377.435,877.194l1.187.7v-.018l-1.187-.686Z",
    transform: "translate(-23146.17 17622.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M-376.585,791.02l.024-1.405-.614.357,0,1.394Z",
    transform: "translate(-23146.342 17681.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M-376.753,846.777l-.6.349,0,1.383.6-.352Z",
    transform: "translate(-23146.223 17643.354)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuoteIcon);
export default __webpack_public_path__ + "static/media/request-quote-icon.96671707b3c1d9fd4d6a98031f4c7520.svg";
export { ForwardRef as ReactComponent };